import { createApp } from 'vue';
import Snackbar from './Snackbar.vue';
import { EventBus } from '../../eventbus';
let snackbarActive = false;
let timeout;
let closing = false;
const sleep = time => new Promise(resolve => {
    setTimeout(resolve, time);
});
const close = function closeFct() {
    snackbarActive = false;
    if (timeout) {
        clearTimeout(timeout);
    }
    EventBus.$emit('close');
};
const revealSnackbar = async (type, options) => {
    if (snackbarActive && closing) {
        return;
    }
    if (snackbarActive) {
        close();
        closing = true;
        await sleep(400);
        closing = false;
    }
    snackbarActive = true;
    const closeTime = (options === null || options === void 0 ? void 0 : options.forever) ? undefined : (options === null || options === void 0 ? void 0 : options.time) || 3000;
    if (closeTime) {
        timeout = setTimeout(close, closeTime);
    }
    EventBus.$emit('add', { type, options });
};
const SnackbarService = {
    show: async (options) => {
        await revealSnackbar('show', options);
    },
    success: async (options) => {
        await revealSnackbar('success', options);
    },
    danger: async (options) => {
        await revealSnackbar('danger', options);
    }
};
const SnackbarPlugin = {
    install: () => {
        try {
            const container = document.createElement('div');
            container.id = `snackbar-${Date.now()}`;
            document.body.appendChild(container);
            const snackbarWrapper = createApp(Snackbar, {
                // onClose gets triggered by 'close' emit from Snackbar
                async onClose() {
                    close();
                    closing = true;
                    await sleep(400);
                    closing = false;
                }
            });
            snackbarWrapper.mount(`#${container.id}`);
        }
        catch (e) {
            console.error('Failed to install SnackbarPlugin', e);
        }
    }
};
export default function installSnackbarPlugin(nuxtApp) {
    nuxtApp.provide('snack', SnackbarService);
    // import according to https://nuxt.com/docs/guide/directory-structure/plugins#vue-plugins
    nuxtApp.vueApp.use(SnackbarPlugin);
}
//# sourceMappingURL=index.js.map